/*eslint-disable*/
import cloneDeep from 'lodash/cloneDeep';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import MaskedInput from 'react-text-mask';
import emailMask from 'text-mask-addons/dist/emailMask';
import { uploadImageFile } from '../../api/imageAPI';

// @mui/material components
import { makeStyles } from '@mui/styles';

// material ui icons
import BusinessIcon from '@mui/icons-material/Business';

// core components
import CustomInput from 'components/CustomInput/CustomInput.js';
import GridContainer from 'components/Grid/GridContainer.js';
import GridItem from 'components/Grid/GridItem.js';

import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardHeader from 'components/Card/CardHeader.js';
import CardIcon from 'components/Card/CardIcon.js';
import Button from 'components/CustomButtons/Button.js';
import ImageUpload from 'components/CustomUpload/ImageUpload.js';
import { PromptAlert } from 'features/ux/RouterPrompt.js';

// style for this view
import styles from 'assets/jss/material-dashboard-pro-react/views/clientEditStyle.js';

// Redux
import { selectViewIsDirty, setViewIsDirty } from 'features/ux/uxSlice';
import { selectClient, setSessionClient } from '../../features/session/sessionSlice';
import { Box } from '@mui/material';
import { useUpdateClientMutation } from 'api/client.api';
import { isValidEmail } from '../../utils';

const useStyles = makeStyles(styles);
let shouldClearFromDeferred = null;

const phoneMaskProps = {
  guide: false,
  placeholderChar: '\u2000',
  mask: [
    '(',
    /[1-9]/,
    /\d/,
    /\d/,
    ')',
    ' ',
    /\d/,
    /\d/,
    /\d/,
    '-',
    /\d/,
    /\d/,
    /\d/,
    /\d/,
  ],
};

function phoneMaskCustom(props) {
  let { inputRef, ...other } = props;

  if (typeof inputRef !== 'function') {
    inputRef = () => {};
  }

  return (
    <MaskedInput
      {...other}
      {...phoneMaskProps}
      ref={(ref) => {
        inputRef(ref ? ref.inputElement : null);
      }}
    />
  );
}

export default function ClientEdit() {
  const dispatch = useDispatch();
  const client = useSelector(selectClient);  
  const viewIsDirty = useSelector(selectViewIsDirty);
  
  const [updateClient] = useUpdateClientMutation();

  const classes = useStyles();

  const [logo, setLogo] = useState(client.logo);
  const [logoFile, setLogoFile] = useState(null);
  const [logoError, setLogoError] = useState('');

  const [name, setName] = useState(client.name);
  const [nameState, setNameState] = useState('');
  const [nameError, setNameError] = useState('');
  const [description, setDescription] = useState(client.description);
  const [descriptionState, setDescriptionState] = useState('');
  const [descriptionError, setDescriptionError] = useState('');
  const [billingName, setBillingName] = useState(
    client.billing_contact.full_name
  );
  const [billingNameState, setBillingNameState] = useState('');
  const [billingNameError, setBillingNameError] = useState('');
  const [billingPhone, setBillingPhone] = useState(
    client.billing_contact.phone_number
  );
  const [billingPhoneState, setBillingPhoneState] = useState('');
  const [billingPhoneError, setBillingPhoneError] = useState('');
  const [billingEmail, setBillingEmail] = useState(
    client.billing_contact.email_address
  );
  const [billingEmailState, setBillingEmailState] = useState('');
  const [billingEmailError, setBillingEmailError] = useState('');
  const [administratorName, setAdministratorName] = useState(
    client.administrative_contact.full_name
  );
  const [administratorNameState, setAdministratorNameState] = useState('');
  const [administratorNameError, setAdministratorNameError] = useState('');
  const [administratorPhone, setAdministratorPhone] = useState(
    client.administrative_contact.phone_number
  );
  const [administratorPhoneState, setAdministratorPhoneState] = useState('');
  const [administratorPhoneError, setAdministratorPhoneError] = useState('');
  const [administratorEmail, setAdministratorEmail] = useState(
    client.administrative_contact.email_address
  );
  const [administratorEmailState, setAdministratorEmailState] = useState('');
  const [administratorEmailError, setAdministratorEmailError] = useState('');

  const [showDirtyClearAlert, setShowDirtyClearAlert] = React.useState(false);

  // function that returns true if value is email, false otherwise
  const verifyEmail = (value, original) => {
    if (isValidEmail(value)) {
      if (value !== original) {
        dispatch(setViewIsDirty(true));
      }
      return true;
    }
    return false;
  };

  const verifyLength = (value, original, length, required = true) => {
    if (value && value.length >= length) {
      if (value !== original) {
        dispatch(setViewIsDirty(true));
      }
      return true;
    } else if (!required && (!value || value.length === 0)) {
      if (value !== original) {
        dispatch(setViewIsDirty(true));
      }
      return true;
    }
    return false;
  };

  const emailMaskProps = {
    guide: false,
    placeholderChar: '\u2000',
    mask: emailMask,
  };

  const emailMaskCustom = (props) => {
    let { inputRef, ...other } = props;

    if (typeof inputRef !== 'function') {
      inputRef = () => {};
    }

    return (
      <MaskedInput
        {...other}
        {...emailMaskProps}
        ref={(ref) => {
          inputRef(ref ? ref.inputElement : null);
        }}
      />
    );
  };

  const changeClick = async () => {
    var error = false;
    var updatedClient = cloneDeep(client);

    if (name === '' && nameState === '') {
      error = true;
      setNameState('error');
    }
    if (description === '' && descriptionState === '') {
      error = true;
      setDescriptionState('error');
    }
    if (billingName === '' && billingNameState === '') {
      error = true;
      setBillingNameState('error');
    }
    if (billingPhone === '' && billingPhoneState === '') {
      error = true;
      setBillingPhoneState('error');
    }
    if (billingEmail === '' && billingEmailState === '') {
      error = true;
      setBillingEmailState('error');
    }
    if (administratorName === '' && administratorNameState === '') {
      error = true;
      setAdministratorNameState('error');
    }
    if (administratorPhone === '' && administratorPhoneState === '') {
      error = true;
      setAdministratorPhoneState('error');
    }
    if (administratorEmail === '' && administratorEmailState === '') {
      error = true;
      setAdministratorEmailState('error');
    }

    if (logoFile) {
      const logo_url = await uploadImageFile(client._id, logoFile);
      if (logo_url === '') {
        setLogoError('There was an error uploading your logo');
        error = true;
      }
      setLogo(logo_url)
      updatedClient.logo = logo_url;
    }
    else {
      updatedClient.logo = logo;
    }

    if (error === false) {
      updatedClient.name = name;
      updatedClient.description = description;
      updatedClient.billing_contact.full_name = billingName;
      updatedClient.billing_contact.phone_number = billingPhone;
      updatedClient.billing_contact.email_address = billingEmail;
      updatedClient.administrative_contact.full_name = administratorName;
      updatedClient.administrative_contact.phone_number = administratorPhone;
      updatedClient.administrative_contact.email_address = administratorEmail;

      const response = await updateClient(updatedClient).unwrap();
      dispatch(setSessionClient(response));
      dispatch(setViewIsDirty(false));
    }
  };

  const revertForm = () => {
    if (viewIsDirty) {
      setShowDirtyClearAlert(true);
      return;
    }

    setLogo(client.logo);
    setName(client.name);
    setNameState('');
    setDescription(client.description);
    setDescriptionState('');
    setBillingName(client.billing_contact.full_name);
    setBillingNameState('');
    setBillingPhone(client.billing_contact.phone_number);
    setBillingPhoneState('');
    setBillingEmail(client.billing_contact.email_address);
    setBillingEmailState('');
    setAdministratorName(client.administrative_contact.full_name);
    setAdministratorNameState('');
    setAdministratorPhone(client.administrative_contact.phone_number);
    setAdministratorPhoneState('');
    setAdministratorEmail(client.administrative_contact.email_address);
    setAdministratorEmailState('');
  };

  useEffect(() => {
    dispatch(setViewIsDirty(false));
  }, []);

  useEffect(() => {
    if (shouldClearFromDeferred) {
      shouldClearFromDeferred = false;
      revertForm();
    }
  }, [viewIsDirty]);

  const isValidForm = () => {
    return (
      nameError == '' &&
      descriptionError == '' &&
      billingNameError == '' &&
      billingPhoneError == '' &&
      billingEmailError == '' &&
      administratorNameError == '' &&
      administratorPhoneError == '' &&
      administratorEmailError == ''
    );
  };

  return (
    <>
      {showDirtyClearAlert && (
        <PromptAlert
          title='Discard Changes?'
          message='You have unsaved changes. Are you sure you want to discard them?'
          onConfirm={() => {
            shouldClearFromDeferred = true;
            setShowDirtyClearAlert(false);
            dispatch(setViewIsDirty(false));
          }}
          onCancel={() => {
            setShowDirtyClearAlert(false);
            shouldClearFromDeferred = false;
          }}
        />
      )}
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <Card>
            <CardHeader color='rose' icon>
              <CardIcon color='rose'>
                <BusinessIcon />
              </CardIcon>
              <h4 className={classes.cardIconTitle}>Company Information</h4>
            </CardHeader>
            <CardBody>
              <GridContainer>
                <GridItem xs={6} sm={4} md={3}>
                  <ImageUpload
                    image={logo}
                    getImageFile={(image) => setLogoFile(image)}
                    onRemoveImageFile={() => {
                      setLogo('');
                      setLogoFile(null);
                    }}
                  />
                  { logoError !== '' ? (
                    <p className={classes.textDanger}>
                      { logoError }
                    </p>
                  ) : null }
                </GridItem>
                <GridItem xs={6} sm={8} md={9}>
                  <Box sx={{display: 'flex', flexDirection: 'column', justifyContent: 'space-between', height: '100%'}}>
                    <Box>
                      <CustomInput
                        helperText={
                          nameState === 'error'
                            ? nameError ?? 'An error has occurred'
                            : false
                        }
                        success={nameState === 'success'}
                        error={nameState === 'error'}
                        labelText='Company Name'
                        id='name'
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          value: name,
                          onChange: (event) => {
                            if (verifyLength(event.target.value, name, 3)) {
                              setNameState('success');
                              setNameError('');
                            } else {
                              setNameState('error');
                              setNameError(
                                'Field must contain at least 3 alphanumeric or special characters'
                              );
                            }
                            setName(event.target.value);
                          },
                          autoComplete: 'off',
                        }}
                      />
                      <CustomInput
                        helperText={
                          descriptionState === 'error'
                            ? descriptionError ?? 'An error has occurred'
                            : false
                        }
                        success={descriptionState === 'success'}
                        error={descriptionState === 'error'}
                        labelText='Company Description'
                        id='description'
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          value: description,
                          onChange: (event) => {
                            if (
                              verifyLength(
                                event.target.value,
                                description,
                                3,
                                false
                              )
                            ) {
                              setDescriptionState('success');
                              setDescriptionError('');
                            } else {
                              setDescriptionState('error');
                              setDescriptionError(
                                'Field must contain at least 3 alphanumeric or special characters'
                              );
                            }
                            setDescription(event.target.value);
                          },
                          autoComplete: 'off',
                        }}
                      />
                    </Box>
                    <Box>
                      <Button
                        color='rose'
                        onClick={changeClick}
                        disabled={!viewIsDirty || !isValidForm()}
                        className={classes.registerButton}
                        >
                        Save Changes
                      </Button>
                      <Button
                        color='secondary'
                        onClick={() => revertForm()}
                        className={classes.registerButton}
                        disabled={!viewIsDirty}
                        >
                        Cancel
                      </Button>
                    </Box>
                  </Box>
                </GridItem>
              </GridContainer>
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    </>
  );
}
